<template>
  <div>
<!--    <div>-->
<!--    <div class="remington-typed-font full-height text-align-center">-->
<!--      <div class="inline-block margin-auto width-90 full-height vertical-middle">-->
<!--        <nav class="navigationList inline-block">-->
<!--          <ul>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'AboutUS'}">General</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'StructureMain'}">Structure</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'CampaignsMain'}">Campaigns</router-link></li>&lt;!&ndash;              <li>|</li>&ndash;&gt;-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'ProceduresMain'}">Procedures</router-link></li>-->
<!--            <li class="navbar-tabs"><router-link :to="{name: 'RulesMain'}">Rules</router-link></li>-->
<!--          </ul>-->
<!--        </nav>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>RULES OF ENGAGEMENT (ROE)</h1>
      <br><br>
    </div>
    <div class="text-align-left">
      <table class="td">
        <thead>
        <tr>
          <th><b>Target Type</b></th>
          <th><b>Attack Allowed / <br> Not Allowed</b></th>
          <th><b>Interpretation of Effects</b></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td><br></td>
          <td><br></td>
          <td><br></td>
        </tr>
        <tr>
          <td>Aircraft on the ground at an airfield.<br>
            (incl. stationary, taxiing, rolling, or having landed, ditched, crash landed etc.)
          </td>
          <td>Allowed. <br>
            On a Vulnerable Airfield in that mission.<br>
            Otherwise, not allowed.
          </td>
          <td>Pilot deaths / wounds do not count against any affected targets.<br>
            Between spawning in and take off, aircraft Lost or Damaged status for affected targets do not count, and the pilot may spawn in again.<br>
            For aircraft that have landed, ditched, or crash landed, Lost or Damaged status for affected targets do count.<br>
            Claims may be submitted in all cases, but as a Ground Target claim.<br>
          </td>
        </tr>
        <tr>
          <td><br></td>
          <td><br></td>
          <td><br></td>
        </tr>
        <tr>
          <td>Aircraft on the ground away from airfields
            (i.e. landed, ditched, crash landed etc.)
          </td>
          <td>Allowed.</td>
          <td>Pilot deaths / wounds do not count against any affected targets.<br>
            Aircraft Lost or Damaged status for affected targets do count.<br>
            Claims may be submitted in all cases, but as a Ground Target claim.<br>
          </td>
        </tr>
        <tr>
          <td><br></td>
          <td><br></td>
          <td><br></td>
        </tr>
        <tr>
          <td>Aircraft airborne, having just taken off from or on landing approach to an airfield.</td>
          <td>Allowed. <br>
            If the airfield is on the Vulnerable Airfield List for that mission.<br>
            Otherwise, not allowed.
          </td>
          <td>Normal rules apply.</td>
        </tr>
        <tr>
          <td><br></td>
          <td><br></td>
          <td><br></td>
        </tr>
        <tr>
          <td>Parachutes.</td>
          <td>Allowed* (see notes)</td>
          <td>Pilot deaths / wounds resulting from deliberate or accidental attacks do not count.</td>
        </tr>
        </tbody>
      </table>
      <br>
      <h2>Explanation / Amplification</h2>
      <ul>
        <li>The Vulnerable Airfield List for any given mission will typically include most airfields, with specific exceptions for those active bases which are either far enough away from the front line or sufficiently well defended as to be considered immune from attack.
        </li>
        <br>
        <li>If on the ground, a pilot character is not affected by death and wounds inflicted by air attack. Taking off from a Vulnerable Airfield immediately puts a pilot/character at risk.
        </li>
        <br>
        <li>If attacking a Vulnerable Airfield, the only restriction is that claims against aircraft on the ground should be submitted as Ground Targets. Making pilots submit Ground Target claims for attacking aircraft on the ground, at or away from airfields, should remove much of the incentive for doing so.
        </li>
        <br>
        <li>The Mission Planner (and Mission Control if in operation) should, where possible, avoid situations where airfields come under attack just as units are taking off on their first sortie of the mission.
        </li>
        <br>
        <li>Mission Planner (and Mission Control if in operation) can, if necessary, intervene to prevent or stop an airfield attack.
        </li>
        <br>
        <li>Individual scenarios may allow the replacement of damaged aircraft, or aircraft destroyed during or after landing at their starting base in order for the pilot to continue the mission.
        </li>
        <br>
        <li>No attack should be made if any doubt exists on its validity (i.e. unsure of position and or the status of an airfield).
        </li>
        <br>
        <li>Pilots are free to impose their own ‘code of honour’ on what targets they engage, these rules just provide an official, common baseline.
        </li>
        <br>
        <li>The restriction on shooting parachutists is lifted for the Autumn 1944 Campaign to allow the Luftwaffe to engage paratroopers during dropping operations, as they were ordered to do historically.  Given the difficulty of distinguishing paratroopers from bailed out pilots, all parachutists may be engaged but any wounds / death to pilots is ignored for character recording purposes.
        </li>
      </ul>
      <p>Any transgressions of these rules should be reported through the chain of command or to Mission / Ground Control (if in operation) and will be dealt with by the FTC leadership team as required.
      </p>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "InfoTemplate"
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/info/RulesOfEngagement.vue